import Immutable from "immutable";
import serialize from "services/serialize";

const modalBillingPlansMap = Immutable.Map({
  plan: "",
  isLoading: false
});

export const modalBillingPlans = (state = modalBillingPlansMap, action) => {
  switch (action.type) {
    case "SET_MODAL_BILLING_PLANS":
      return state.merge(action.payload);

    case "GET_BILLINGS_SUCCESS": {
      const billingPlan = serialize(action.response.data.billing_plan);
      let newState;

      if (billingPlan.isEmpty()) {
        return state;
      }

      newState = state.set("isLoading", false);

      if (billingPlan.has("availablePlans")) {
        const subscriptionPlanId = billingPlan.getIn([
          "subscription",
          "planId"
        ]);

        const subscriptionPlan = billingPlan
          .get("availablePlans")
          .find(plan => plan.get("planId") === subscriptionPlanId);

        newState = newState.set("plan", subscriptionPlan);
      }

      return newState;
    }

    case "UPDATE_PLAN_REQUEST":
      return state.set("isLoading", true);

    case "GET_BILLINGS_FAILURE":
    case "UPDATE_PLAN_SUCCESS":
    case "UPDATE_PLAN_FAILURE":
      return state.set("isLoading", false);

    default:
      return state;
  }
};
